export const RESPONDENT_STATUS_CODE = {
  PS_SIDE_IN_PROGRESS: 14,
  BUYER_SIDE_IN_PROGRESS: 16,
  BUYER_QUOTA_FULL: 17,
  BUYER_TERMINATION: 18,
  BUYER_DROP: 19,
  BUYER_QUALITY_TERMINATION: 20,
  COMPLETE: 21,
  PS_LOI_THRESHOLD_FAILURE: 29,
  BUYER_SECURITY: 30,
  BUYER_HASH_SECURITY: 31,
  BUYER_RECONCILIATION_REJECT: 33,
  PS_PSID_GEO_TERMINATION: 38,
  BUYER_PS_API_FAIL: 84,
} as const;

export const RESPONDENT_VALID_CLICK_CODES: number[] = [
  RESPONDENT_STATUS_CODE.PS_SIDE_IN_PROGRESS,
  RESPONDENT_STATUS_CODE.BUYER_SIDE_IN_PROGRESS,
  RESPONDENT_STATUS_CODE.BUYER_QUALITY_TERMINATION,
  RESPONDENT_STATUS_CODE.COMPLETE,
  RESPONDENT_STATUS_CODE.PS_LOI_THRESHOLD_FAILURE,
  RESPONDENT_STATUS_CODE.BUYER_SECURITY,
  RESPONDENT_STATUS_CODE.PS_PSID_GEO_TERMINATION,
  RESPONDENT_STATUS_CODE.BUYER_PS_API_FAIL,
];
